"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExcelTitle = getExcelTitle;
exports.getPageName = getPageName;
exports.getPageTitle = getPageTitle;
var _settings = _interopRequireDefault(require("@/settings"));
var _lang = _interopRequireDefault(require("@/lang"));
var title = _settings.default.title || 'Vue Element Admin';
function getPageName(key) {
  var hasKey = _lang.default.te("route.".concat(key));
  if (hasKey) {
    return _lang.default.t("route.".concat(key));
  }
  return key;
}
function getPageTitle(key) {
  var pageName = getPageName(key);
  if (pageName) {
    return "".concat(pageName, " - ").concat(title);
  }
  return "".concat(title);
}
function getExcelTitle(key) {
  var pageName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  pageName = getPageName(key) || pageName;
  return "".concat(pageName);
}